"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bulkSetActiveSchema = exports.updateDepartmentSchema = exports.createDepartmentSchema = exports.departmentShape = exports.departmentTypeEnum = void 0;
const zod_1 = require("zod");
// Department Master enterprise rebuild — real 8-value taxonomy,
// replacing the old CLINICAL/ADMINISTRATIVE pair (see the Prisma
// migration's own doc comment for why this was a safe hard replace).
exports.departmentTypeEnum = zod_1.z.enum([
    'CLINICAL',
    'DIAGNOSTIC',
    'CLINICAL_SUPPORT',
    'ADMINISTRATION',
    'FACILITY',
    'ACADEMIC',
    'PROJECT',
    'BRANCH',
]);
exports.departmentShape = {
    branchId: zod_1.z.string().uuid().nullable().optional(),
    code: zod_1.z.string().min(1).max(20),
    name: zod_1.z.string().min(1).max(255),
    type: exports.departmentTypeEnum,
    category: zod_1.z.string().max(100).nullable().optional(),
    module: zod_1.z.string().max(100).nullable().optional(),
    description: zod_1.z.string().nullable().optional(),
    displayOrder: zod_1.z.number().int().min(0).optional(),
    color: zod_1.z.string().max(20).nullable().optional(),
    icon: zod_1.z.string().max(50).nullable().optional(),
    isClinical: zod_1.z.boolean().optional(),
    isAppointmentEnabled: zod_1.z.boolean().optional(),
    isOpEnabled: zod_1.z.boolean().optional(),
    isIpEnabled: zod_1.z.boolean().optional(),
    isOtEnabled: zod_1.z.boolean().optional(),
    isBillingEnabled: zod_1.z.boolean().optional(),
    isInternalTransferApplicable: zod_1.z.boolean().optional(),
    costCenterCode: zod_1.z.string().max(50).nullable().optional(),
    /**
     * The ACCOUNT HEAD this department's money is filed under — OBSTETRICS
     * pointing at `OBST & GYNAE · CONS FEE - OP`, because its own row owns no
     * heads. Resolution reads that head's DEPARTMENT, so the department
     * inherits all of its heads rather than the one that was picked.
     *
     * Null means "my own heads", which is what every department that owns them
     * keeps.
     */
    accountHeadId: zod_1.z.string().uuid().nullable().optional(),
    headUserId: zod_1.z.string().uuid().nullable().optional(),
    isActive: zod_1.z.boolean().optional(),
};
exports.createDepartmentSchema = zod_1.z.object(exports.departmentShape);
exports.updateDepartmentSchema = exports.createDepartmentSchema.partial();
/** `PATCH /departments/status` — Bulk Activate/Bulk Deactivate. */
exports.bulkSetActiveSchema = zod_1.z.object({
    ids: zod_1.z.array(zod_1.z.string().uuid()).min(1),
    isActive: zod_1.z.boolean(),
});
//# sourceMappingURL=department.schema.js.map